export enum ProjectKey {
  Breviary = 'breviary',
  HealthWarden = 'health-warden',
  Txm = 'txm',
  Datavid = 'datavid',
  Ekg = 'heart',
  Ecl = 'ecl',
  CovidVaxx = 'covid-vaxx',
}
